import React from "react";
import styles from "./callhistory.module.css";
import { formatHm } from "./callhistoryformat";

const MISSED_EVENTS = ["ABANDON", "EXITWITHTIMEOUT", "EXITEMPTY", "EXITWITHKEY"];
const CONNECT_EVENTS = ["CONNECT", "COMPLETECALLER", "COMPLETEAGENT"];
const MUTED_EVENTS = ["RINGNOANSWER", "RINGCANCELED"];

//통화 1건의 queuelog 여정 타임라인 (라벨은 서버에서 한글화)
const JourneyList : React.FC<any> = (props) => {
    if (props.loading) {
        return <div className={styles.journeyBox}><div className={`${styles.journeyItem} ${styles.journeyMuted}`}>여정 불러오는 중...</div></div>;
    }
    if (props.error) {
        return <div className={styles.journeyBox}><div className={`${styles.journeyItem} ${styles.journeyMuted}`}>여정 정보를 불러오지 못했습니다</div></div>;
    }
    const events : any[] = props.events || [];
    if (events.length === 0) {
        return <div className={styles.journeyBox}><div className={`${styles.journeyItem} ${styles.journeyMuted}`}>{props.direction === "outbound" ? "발신 통화는 큐 여정이 없습니다" : "여정 기록 없음"}</div></div>;
    }
    return (
        <div className={styles.journeyBox}>
            {
                events.map((e, i) => {
                    const cls = MISSED_EVENTS.indexOf(e.event) !== -1 ? styles.journeyMissed
                        : CONNECT_EVENTS.indexOf(e.event) !== -1 ? styles.journeyConnected
                        : MUTED_EVENTS.indexOf(e.event) !== -1 ? styles.journeyMuted : "";
                    return (
                        <div key={i} className={`${styles.journeyItem} ${cls}`}>
                            <span className={styles.journeyTime}>{formatHm(e.time)}</span>
                            <span>{e.label}</span>
                        </div>
                    );
                })
            }
        </div>
    );
};

export default JourneyList;
